<ion-app>
    <div *ngIf="isHomePage"
         class="draggable-fullscreen-btn"
         [style.left.px]="btnX"
         [style.top.px]="btnY"
         (touchstart)="onDragStart($event)"
         (touchmove)="onDragMove($event)"
         (touchend)="onDragEnd($event)"
         (mousedown)="onDragStart($event)"
         title="Toàn màn hình / Fullscreen">
        <svg *ngIf="!isFullscreen" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"/>
        </svg>
        <svg *ngIf="isFullscreen" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"/>
        </svg>
    </div>
    <ion-router-outlet [swipeGesture]="false" animated="false"></ion-router-outlet>
</ion-app>
